import { TDefaultService } from 'features/doctors/store/types'
import styles from './DefaultService.module.scss'
import { FC, useEffect, useState } from 'react'

type DefaultServiceProps = {
  service: TDefaultService;
}

export const DefaultService: FC<DefaultServiceProps> = ({
  service
}) => {

  const [ isOpen, setIsOpen ] = useState<boolean>(false);
  const [ isAllowOpen, setIsAllowOpen ] = useState<boolean>(false);
  const [ priceString, setPriceString ] = useState<string>('');

  // const open = () => {
  //   if (!isAllowOpen) return;
  //   setIsOpen(true);
  // }

  const close = () => {
    if (!isAllowOpen) return;
    setIsOpen(false);
  }

  const toggleOpen = () => {
    if (!isAllowOpen) return;

    setIsOpen(!isOpen);
  }

  useEffect(() => {
    const priceValue = typeof service.price_value === 'string' ? parseFloat(service.price_value) : service.price_value
    const priceStr = priceValue.toLocaleString('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      minimumSignificantDigits: 2
    })

    setPriceString(priceStr);

    if (service.about?.trim?.() || service.indications?.trim?.() || service.preparation?.trim?.()) {
      setIsAllowOpen(true);
    }
  },[service])

  return (
    <div className={styles.defaultService}>
      <button 
        className={`${styles.defaultService__trigger} ${ isOpen&&isAllowOpen ? styles.defaultService__trigger_active : ''}`}
        onClick={toggleOpen}
      >
        <span>{service.name}</span>
        <span>{priceString}</span>
      </button>

      {isOpen&&isAllowOpen && 
      <div className={styles.defaultService__body}>
        <div className={styles.defaultService__close} onClick={close}></div>

        {service.about?.trim?.() && 
        <div className={styles.defaultService__item}>
          <div className={styles.defaultService__itemtext}>
            {service.about}
          </div>
        </div>
        }

        {service.indications?.trim?.() && 
        <div className={styles.defaultService__item}>
          <div className={styles.defaultService__itemtitle}>Показания</div>
          <div className={styles.defaultService__itemtext}>
            {service.indications}
          </div>
        </div>
        }

        {service.preparation?.trim?.() && 
        <div className={styles.defaultService__item}>
          <div className={styles.defaultService__itemtitle}>Подготовка</div>
          <div className={styles.defaultService__itemtext}>
            {service.preparation}
          </div>
        </div>
        }
      </div>
      }
    </div>
  )
}